// <Can> — permission-gated rendering. For partner sessions, getEffectivePermissions
// intersects with the mandate scope (B3-RBAC-CATALOG §2.5). UI affordance only. PLAN-C1.11.
import { type ReactNode } from "react";
import { hasPermission, type PermissionCode } from "@sympllex/auth";
import { useSession } from "./session";

export function Can({ perm, children, fallback = null }: { perm: PermissionCode; children: ReactNode; fallback?: ReactNode }) {
  const session = useSession();
  return <>{hasPermission(session, perm) ? children : fallback}</>;
}
